export default [
  {
    path: '/login',
    name: 'login',
    props: { showError: false },
    component: () => import(/* webpackChunkName: "login" */ '../../views/v1/LoginView.vue')
  },
  {
    path: '/login/error/:sessionId?',
    name: 'login-error',
    props: { showError: true },
    component: () => import(/* webpackChunkName: "login" */ '../../views/v1/LoginView.vue')
  },
  {
    path: '/login/confirm/:sessionId?',
    name: 'login-confirm',
    component: () => import(/* webpackChunkName: "confirm" */ '../../views/v1/ConfirmView.vue')
  },
  /* RESET PASSWORD  */
  {
    path: '/forgot',
    name: 'reset-password-step1',
    component: () => import(/* webpackChunkName: "reset-password-step1" */ '../../views/v1/ResetStep1.vue')
  },
  // ERROR
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '../../views/v1/ErrorView.vue')
  },
  {
    path: '/error-500',
    name: 'error500',
    component: () => import(/* webpackChunkName: "error-500" */ '../../views/v1/ErrorView.vue')
  },
  {
    path: 'restricted',
    name: 'restricted',
    component: () => import(/* webpackChunkName: "restricted" */ '../../views/v1/RestrictedAccess.vue')
  }
]
